/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';


export default function DishDetailsHowMuch(props) {
    const {
        howMuch = null,
        weight = null,
        weightText =null,
    } = props;

    if (howMuch) {
        return <div dangerouslySetInnerHTML={{ __html: howMuch }} />
    }

    return (
        <p className="ny__dishes-details__content">
            <b>
                <span className="num">{weight}</span>
                &nbsp;
                {weightText}
            </b>
        </p>
    );
}

DishDetailsHowMuch.propTypes = {
    howMuch: PropTypes.string,
    weight: PropTypes.string,
    weightText: PropTypes.string,
};
